import {
  GET_PROJECTS_LIST_REQUEST,
  GET_PROJECTS_LIST_SUCCESS,
  GET_PROJECTS_LIST_FAILURE,
  GET_PROJECT_REQUEST,
  GET_PROJECT_SUCCESS,
  GET_PROJECT_FAILURE,
  UPDATE_PROJECT_LOGO_SUCCESS
} from './actions'
import {CLEAR_PROJECT_FILES} from '../files/actions'
import {SIGN_OUT} from '../auth/actions'

const initialState = {
  isFetching: false,
  isFetched: true,
  list: {},
  details: {}
};

export default function projectReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PROJECTS_LIST_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_PROJECTS_LIST_SUCCESS: {
      const projects = {};

      if ( action.payload ) {
        Object.values(action.payload).filter((p) => !p.isArchived).forEach((p) => {
          projects[p.id] = p;
        })
      }

      return {
        ...state,
        list: projects || {},
        isFetching: false,
        isFetched: true
      }
    }
    case UPDATE_PROJECT_LOGO_SUCCESS: {
      const details = { ...state.details };
      details.companyLogo = action.payload.url;
      return {
        ...state,
        details: details
      }
    }
    case GET_PROJECTS_LIST_FAILURE: {
      return {
        ...state,
        isFetching: false
      }
    }
    case GET_PROJECT_REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case GET_PROJECT_SUCCESS: {
      return {
        ...state,
        details: action.payload,
        isFetching: false
      }
    }
    case GET_PROJECT_FAILURE: {
      return {
        ...state,
        isFetching: false
      }
    }
    case CLEAR_PROJECT_FILES: {
      return {
        ...state,
        details: {}
      }
    }
    case SIGN_OUT: {
      return {
        ...initialState
      }
    }
    default: {
      return {...state};
    }
  }
}
